import * as React from 'react'

export const DevIcon = React.forwardRef<
  SVGSVGElement,
  {
    color?: string
    width?: number
    height?: number
  } & React.SVGProps<SVGElement>
>(({ style, ...props }, ref) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}
      ref={ref}
    >
      <g fillRule="evenodd" clipRule="evenodd" fill="currentColor">
        <path d="M4.354 5.647a.5.5 0 0 1 0 .707L2.707 8l1.647 1.647a.5.5 0 1 1-.708.707l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .708 0ZM11.646 5.647a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.708-.707L13.293 8l-1.647-1.646a.5.5 0 0 1 0-.707ZM10.186 2.536a.5.5 0 0 1 .278.65l-4 10a.5.5 0 0 1-.928-.372l4-10a.5.5 0 0 1 .65-.278Z" />
      </g>
    </svg>
  )
})
